var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "technology",
            "title": "핵심기술",
            "src": "/images/sub/subvisual-technology.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first pb-0",
    attrs: {
      "id": "technology-core"
    },
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mw-1920px mx-auto mb-30px mb-md-40px mb-lg-60px px-12px px-xl-0px",
          attrs: {
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-img', {
          attrs: {
            "max-width": "1356",
            "aspect-ratio": 1356 / 468,
            "src": "/images/sub/technology/technology-img.png"
          }
        })], 1), _c('v-container', [_c('div', {
          staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
        }, [_c('h4', {
          staticClass: "tit tit--lg",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "200"
          }
        }, [_vm._v("핵심기술")])]), _c('div', {
          staticClass: "tit-wrap tit-wrap--sm"
        }, [_c('v-divider', {
          staticClass: "grey lighten-2"
        })], 1), _c('div', {
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "200"
          }
        }, [_c('v-row', {
          staticClass: "ma-n4px ma-md-n8px ma-lg-n20px",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-avatar', {
          attrs: {
            "color": "primary",
            "size": _vm.$vuetify.breakpoint.lgAndUp ? 50 : 40
          }
        }, [_c('b', {
          staticClass: "tit tit--xs white--text font-secondary"
        }, [_vm._v("01")])])], 1), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('div', {
          staticClass: "w-md-180px"
        }, [_c('div', {
          staticClass: "tit tit--sm primary--text"
        }, [_vm._v("데이터 기반 리얼데이터 수집")])])]), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "12",
            "md": ""
          }
        }, [_c('p', {
          staticClass: "txt txt--xl"
        }, [_vm._v("이레아이에스는 농가로부터 하루에 2억 여개의 데이터를 취득하여 분석하고 있으며 농가와 상생할 수 있는 다양한 사업의 스마트팜 솔루션을 제안합니다.")])])], 1)], 1), _c('div', {
          staticClass: "mt-20px mt-md-30px mt-lg-40px",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "300"
          }
        }, [_c('v-row', {
          staticClass: "ma-n4px ma-md-n8px ma-lg-n20px",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-avatar', {
          attrs: {
            "color": "primary",
            "size": _vm.$vuetify.breakpoint.lgAndUp ? 50 : 40
          }
        }, [_c('b', {
          staticClass: "tit tit--xs white--text font-secondary"
        }, [_vm._v("02")])])], 1), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('div', {
          staticClass: "w-md-180px"
        }, [_c('div', {
          staticClass: "tit tit--sm primary--text"
        }, [_vm._v("자체센서")])])]), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "12",
            "md": ""
          }
        }, [_c('p', {
          staticClass: "txt txt--xl"
        }, [_vm._v("자체 개발 센서를 통해 식물 뿌리 주변과 외부환경에서 수집된 데이터 기반 재배 관리 알고리즘을 적용하여 농업인들의 보다 쉬운 의사결정을 돕고 있습니다.")])])], 1)], 1), _c('div', {
          staticClass: "mt-20px mt-md-30px mt-lg-40px",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "400"
          }
        }, [_c('v-row', {
          staticClass: "ma-n4px ma-md-n8px ma-lg-n20px",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-avatar', {
          attrs: {
            "color": "primary",
            "size": _vm.$vuetify.breakpoint.lgAndUp ? 50 : 40
          }
        }, [_c('b', {
          staticClass: "tit tit--xs white--text font-secondary"
        }, [_vm._v("03")])])], 1), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('div', {
          staticClass: "w-md-180px"
        }, [_c('div', {
          staticClass: "tit tit--sm primary--text"
        }, [_vm._v("ICT / IoT")])])]), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "12",
            "md": ""
          }
        }, [_c('p', {
          staticClass: "txt txt--xl"
        }, [_vm._v("이레아이에스에서 제공하는 클라우드 서버형 시스템은 자체 개발 하드웨어와 소프트웨어를 사용하여 사용자가 다양한 방법으로 재배환경 모니터링 및 제어관리가 가능합니다.")])])], 1)], 1)])];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "pb-0",
    attrs: {
      "id": "technology-expert"
    },
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mw-1920px mx-auto mb-30px mb-md-40px mb-lg-60px px-12px px-xl-0px",
          attrs: {
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-img', {
          staticClass: "ml-auto",
          attrs: {
            "max-width": "1356",
            "aspect-ratio": 1356 / 468,
            "src": "/images/sub/technology/technology-img2.png"
          }
        })], 1), _c('v-container', [_c('div', {
          staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
        }, [_c('h4', {
          staticClass: "tit tit--lg",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "200"
          }
        }, [_vm._v("각 분야 전문가 포진")])]), _c('div', {
          staticClass: "tit-wrap tit-wrap--sm"
        }, [_c('v-divider', {
          staticClass: "grey lighten-2"
        })], 1), _c('div', {
          staticClass: "overflow-hidden"
        }, [_c('p', {
          staticClass: "txt txt--xl",
          attrs: {
            "data-aos": "fade-down",
            "data-aos-delay": "200"
          }
        }, [_vm._v("이레아이에스는 식품산업, 농업경제, IT, AI빅데이터, 건설, 전자, 전기, 컨설팅 분야 등 10~30년 경력의 각분야 전문가들이 모여 지식을 공유하고 연구하여 스마트팜 산업을 혁신하고 있습니다. 지속 가능한 농업을 위해 더욱 체계적이고 효율적인 농업 생태계를 구축하고 있습니다.")])])])];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "id": "technology-facility"
    },
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mw-1920px mx-auto mb-30px mb-md-40px mb-lg-60px px-12px px-xl-0px",
          attrs: {
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-img', {
          attrs: {
            "max-width": "1356",
            "aspect-ratio": 1356 / 468,
            "src": "/images/sub/technology/technology-img3.png"
          }
        })], 1), _c('v-container', [_c('div', {
          staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
        }, [_c('h4', {
          staticClass: "tit tit--lg",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "200"
          }
        }, [_vm._v("연구 센터와 재배시설")])]), _c('div', {
          staticClass: "tit-wrap tit-wrap--sm"
        }, [_c('v-divider', {
          staticClass: "grey lighten-2"
        })], 1), _c('div', {
          staticClass: "overflow-hidden"
        }, [_c('p', {
          staticClass: "txt txt--xl",
          attrs: {
            "data-aos": "fade-down",
            "data-aos-delay": "200"
          }
        }, [_vm._v("이레아이에스는 자체 R&D 센터와 재배시설을 통해 안전하고 건강한 먹거리를 연구합니다. 이를 통해 농업과 식품분야에서 지속 가능한 발전이 이루어지고, 인류의 먹거리를 더욱 안심하고 즐길 수 있도록 기여하고 있습니다. 이레아이에스의 노력은 미래농업을 더욱 밝게 만들 것입니다.")])])])];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }